import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  viewLiveButton: {
    id: 'course-authoring.course-unit.button.view-live',
    defaultMessage: 'View live version',
  },
  previewButton: {
    id: 'course-authoring.course-unit.button.preview',
    defaultMessage: 'Preview',
  },
});

export default messages;
